import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { addDoc, collection, doc, getDocs, updateDoc } from "firebase/firestore";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { db } from "../Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";
import {
  COLLECTION_FAIXAS_DNIT_ASFALTO,
  CONFIGURACAO_DNIT_ASFALTO_PADRAO,
  FAIXAS_DNIT_ASFALTO,
  faixasDnitAsfaltoPadrao,
} from "./faixasDnitAsfaltoModel";

export default function CadastroFaixasDnitAsfalto() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const [linhas, setLinhas] = useState([]);
  const [configuracao, setConfiguracao] = useState({ ...CONFIGURACAO_DNIT_ASFALTO_PADRAO });
  const [configuracaoId, setConfiguracaoId] = useState(null);

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const snapshot = await getDocs(consultaTenantAtual(collection(db, COLLECTION_FAIXAS_DNIT_ASFALTO)));
    const documentos = snapshot.docs.map((item) => ({ id: item.id, ...item.data() }));

    const configSalva = documentos.find((item) => item.tipo === "configuracao");
    if (configSalva) {
      setConfiguracaoId(configSalva.id);
      setConfiguracao({
        ...CONFIGURACAO_DNIT_ASFALTO_PADRAO,
        ...configSalva,
        vam: {
          ...CONFIGURACAO_DNIT_ASFALTO_PADRAO.vam,
          ...(configSalva.vam || {}),
        },
      });
    } else {
      setConfiguracaoId(null);
      setConfiguracao({ ...CONFIGURACAO_DNIT_ASFALTO_PADRAO });
    }

    const cadastradas = documentos
      .filter((item) => item.tipo !== "configuracao")
      .sort((a, b) => Number(a.ordem) - Number(b.ordem));

    setLinhas(cadastradas.length ? cadastradas : faixasDnitAsfaltoPadrao.map((linha) => ({ ...linha })));
  }

  function alterar(indice, faixaId, campo, valor) {
    setLinhas((atuais) => atuais.map((linha, itemIndice) =>
      itemIndice === indice
        ? { ...linha, [faixaId]: { ...(linha[faixaId] || {}), [campo]: valor } }
        : linha
    ));
  }

  function alterarConfiguracao(campo, valor) {
    setConfiguracao((atual) => ({ ...atual, [campo]: valor }));
  }

  function alterarVam(faixaId, campo, valor) {
    setConfiguracao((atual) => ({
      ...atual,
      vam: {
        ...(atual.vam || {}),
        [faixaId]: {
          ...(atual.vam?.[faixaId] || {}),
          [campo]: valor,
        },
      },
    }));
  }

  async function salvar() {
    for (const linha of linhas) {
      const dados = {
        ordem: Number(linha.ordem),
        astm: linha.astm,
        abertura: linha.abertura,
        tolerancia: linha.tolerancia || "",
        ...Object.fromEntries(FAIXAS_DNIT_ASFALTO.map((faixa) => [faixa.id, linha[faixa.id] || { min: "", max: "" }])),
        atualizadoEm: new Date(),
      };
      if (linha.id) await updateDoc(doc(db, COLLECTION_FAIXAS_DNIT_ASFALTO, linha.id), dados);
      else await addDoc(collection(db, COLLECTION_FAIXAS_DNIT_ASFALTO), aplicarTenantAtual({ ...dados, criadoEm: new Date() }));
    }

    const dadosConfiguracao = {
      tipo: "configuracao",
      normaReferencia: configuracao.normaReferencia || "",
      vaziosMin: configuracao.vaziosMin || "",
      vaziosMax: configuracao.vaziosMax || "",
      rbvMin: configuracao.rbvMin || "",
      rbvMax: configuracao.rbvMax || "",
      estabilidadeMinima: configuracao.estabilidadeMinima || "",
      fluenciaMinima: configuracao.fluenciaMinima || "",
      fluenciaMaxima: configuracao.fluenciaMaxima || "",
      filerAsfaltoMin: configuracao.filerAsfaltoMin || "",
      filerAsfaltoMax: configuracao.filerAsfaltoMax || "",
      resistenciaTracaoMinima: configuracao.resistenciaTracaoMinima || "",
      danoUmidadeMinimo: configuracao.danoUmidadeMinimo || "",
      vam: configuracao.vam || {},
      atualizadoEm: new Date(),
    };

    if (configuracaoId) {
      await updateDoc(doc(db, COLLECTION_FAIXAS_DNIT_ASFALTO, configuracaoId), dadosConfiguracao);
    } else {
      await addDoc(
        collection(db, COLLECTION_FAIXAS_DNIT_ASFALTO),
        aplicarTenantAtual({ ...dadosConfiguracao, criadoEm: new Date() })
      );
    }

    await carregar();
  }

  return <>
    <Navbar />
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Faixas DNIT para Asfalto CBUQ</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Faixas granulométricas e requisitos utilizados na dosagem CBUQ
        </Typography>
        <Button variant="contained" onClick={() => executarSalvamento(salvar)} disabled={salvandoCadastro}>
          {salvandoCadastro ? "Salvando..." : "Salvar alterações"}
        </Button>
      </Paper>

      <Paper sx={{ p: 2, mb: 2, border: "1px solid #e2e8f0", boxShadow: "none" }}>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>Norma e requisitos de validação</Typography>

        <TextField
          fullWidth
          size="small"
          label="Norma de referência"
          value={configuracao.normaReferencia || ""}
          onChange={(event) => alterarConfiguracao("normaReferencia", event.target.value)}
          sx={{ mb: 2 }}
        />

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: 2 }}>
          <TextField size="small" label="Vazios mín. (%)" value={configuracao.vaziosMin || ""} onChange={(e) => alterarConfiguracao("vaziosMin", e.target.value)} />
          <TextField size="small" label="Vazios máx. (%)" value={configuracao.vaziosMax || ""} onChange={(e) => alterarConfiguracao("vaziosMax", e.target.value)} />
          <TextField size="small" label="RBV mín. (%)" value={configuracao.rbvMin || ""} onChange={(e) => alterarConfiguracao("rbvMin", e.target.value)} />
          <TextField size="small" label="RBV máx. (%)" value={configuracao.rbvMax || ""} onChange={(e) => alterarConfiguracao("rbvMax", e.target.value)} />
          <TextField size="small" label="Estabilidade mín. (kgf)" value={configuracao.estabilidadeMinima || ""} onChange={(e) => alterarConfiguracao("estabilidadeMinima", e.target.value)} />
          <TextField size="small" label="Fluência mín. (mm)" value={configuracao.fluenciaMinima || ""} onChange={(e) => alterarConfiguracao("fluenciaMinima", e.target.value)} />
          <TextField size="small" label="Fluência máx. (mm)" value={configuracao.fluenciaMaxima || ""} onChange={(e) => alterarConfiguracao("fluenciaMaxima", e.target.value)} />
          <TextField size="small" label="F/A mín." value={configuracao.filerAsfaltoMin || ""} onChange={(e) => alterarConfiguracao("filerAsfaltoMin", e.target.value)} />
          <TextField size="small" label="F/A máx." value={configuracao.filerAsfaltoMax || ""} onChange={(e) => alterarConfiguracao("filerAsfaltoMax", e.target.value)} />
          <TextField size="small" label="Resist. tração mín. (MPa)" value={configuracao.resistenciaTracaoMinima || ""} onChange={(e) => alterarConfiguracao("resistenciaTracaoMinima", e.target.value)} />
          <TextField size="small" label="Dano por umidade mín." value={configuracao.danoUmidadeMinimo || ""} onChange={(e) => alterarConfiguracao("danoUmidadeMinimo", e.target.value)} />
        </Box>

        <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 3, mb: 1 }}>VAM mínimo</Typography>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#f8fafc" }}>
            <TableRow>
              <TableCell><b>Faixa</b></TableCell>
              <TableCell align="center"><b>3% vazios</b></TableCell>
              <TableCell align="center"><b>4% vazios</b></TableCell>
              <TableCell align="center"><b>5% vazios</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {FAIXAS_DNIT_ASFALTO.map((faixa) => <TableRow key={faixa.id}>
              <TableCell><b>{faixa.label}</b></TableCell>
              {["v3", "v4", "v5"].map((campo) => <TableCell key={campo} align="center">
                <TextField
                  size="small"
                  value={configuracao.vam?.[faixa.id]?.[campo] || ""}
                  onChange={(event) => alterarVam(faixa.id, campo, event.target.value)}
                  inputProps={{ style: { textAlign: "center" } }}
                />
              </TableCell>)}
            </TableRow>)}
          </TableBody>
        </Table>
      </Paper>

      <Paper sx={{ overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
        <Table size="small" sx={{ minWidth: 1100 }}>
          <TableHead sx={{ backgroundColor: "#f8fafc" }}>
            <TableRow>
              <TableCell rowSpan={2} align="center"><b>ASTM</b></TableCell>
              <TableCell rowSpan={2} align="center"><b>Abertura (mm)</b></TableCell>
              {FAIXAS_DNIT_ASFALTO.map((faixa) => <TableCell key={faixa.id} colSpan={2} align="center"><b>{faixa.label}</b></TableCell>)}
              <TableCell rowSpan={2} align="center"><b>Tolerância</b></TableCell>
              <TableCell rowSpan={2} align="center"><b>Histórico</b></TableCell>
            </TableRow>
            <TableRow>{FAIXAS_DNIT_ASFALTO.flatMap((faixa) => [
              <TableCell key={`${faixa.id}-min`} align="center">Min</TableCell>,
              <TableCell key={`${faixa.id}-max`} align="center">Max</TableCell>
            ])}</TableRow>
          </TableHead>
          <TableBody>
            {linhas.map((linha, indice) => <TableRow key={linha.id || linha.astm} hover>
              <TableCell align="center" sx={{ fontWeight: 700 }}>{linha.astm}</TableCell>
              <TableCell align="center">{linha.abertura}</TableCell>
              {FAIXAS_DNIT_ASFALTO.flatMap((faixa) => ["min", "max"].map((campo) => <TableCell key={`${faixa.id}-${campo}`} align="center">
                <TextField size="small" value={linha[faixa.id]?.[campo] || ""} onChange={(event) => alterar(indice, faixa.id, campo, event.target.value)} inputProps={{ style: { textAlign: "center" } }} />
              </TableCell>))}
              <TableCell align="center">{linha.tolerancia || "-"}</TableCell>
              <TableCell align="center">{linha.id && <HistoricoCadastro colecao={COLLECTION_FAIXAS_DNIT_ASFALTO} documentoId={linha.id} registro={linha} />}</TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  </>;
}
